import { drools } from './drools.registry';

const registors = {
  drools: drools,
};

export type RegistorLanguage = typeof registors;

export function getRegistor(language: keyof RegistorLanguage) {
  return registors[language];
}
